<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter04">
<a id="page4">
</a><div class="chapterHead"><a id="page4">
</a><h2 class="chapterTitle"><a id="page4"><span class="xrefInternal"></span></a><a href="#/004TOC#chapter_04"><span class="bold">MICHAEL AND I DON’T WANT ANY MORE CHILDREN</span></a></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">And I certainly won’t miss</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the diaphragm.</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">But I <em class="italic">will</em> miss</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the knowing—</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">the knowing</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">that my body</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">still has that flame</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">glowing at its center,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">that same steady light,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">that fire</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">ready to ignite</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">a freshly forged life,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">yearning for its turn,</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">its freeing,</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">its chance</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">to burn</p>
</div>
<div class="extract">
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">in a brand-new</p>
<p class="extractVerse" style="text-indent: 0%; margin-left: 5%;">human being.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008-chapter04.vue?49077215